// @ts-ignore
import { useInView } from 'react-intersection-observer';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { JPDOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { usePremiumIntent, useStandardIntent } from '@/components/user-context/helpers/cohorts';

import { JPDGetStartedText } from '../../components/get-started-heading';
import { Headings } from '../../components/headings';
import { FreeForThreeCreatorsText, FreeToGetStartedText } from '../../components/sub-heading';
import { InputSubmitButton } from '../../components/submit-input';

export const LoggedOutJpd = () => {
	const { ref } = useInView();
	const isStandard = useStandardIntent();
	const isPremium = usePremiumIntent();

	if (isStandard || isPremium) {
		return (
			<div ref={ref}>
				<LoggedOutJpdStandardPremium />
			</div>
		);
	}

	return (
		<div ref={ref}>
			<LoggedOutJpdFree />
		</div>
	);
};

const LoggedOutJpdFree = () => {
	return (
		<JPDOverlayTemplate size="sm">
			<Headings main={<JPDGetStartedText />} sub={<FreeForThreeCreatorsText />} />
			<AccountCreation Input={<InputSubmitButton />} Submit={null} />
		</JPDOverlayTemplate>
	);
};

const LoggedOutJpdStandardPremium = () => {
	return (
		<JPDOverlayTemplate size="sm">
			<Headings main={<JPDGetStartedText />} sub={<FreeToGetStartedText />} />
			<AccountCreation Input={<InputSubmitButton />} Submit={null} />
		</JPDOverlayTemplate>
	);
};
